import { render, staticRenderFns } from "./UpdateDateEvent.vue?vue&type=template&id=02707228"
import script from "./UpdateDateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateDateEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports